import { render, staticRenderFns } from "./SSlider.vue?vue&type=template&id=52ebd370&scoped=true&"
import script from "./SSlider.vue?vue&type=script&lang=js&"
export * from "./SSlider.vue?vue&type=script&lang=js&"
import style0 from "./SSlider.vue?vue&type=style&index=0&id=52ebd370&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ebd370",
  null
  
)

export default component.exports